import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    delegate: 'Delegate',
    delegateMore: 'Delegate more',
    withdraw: 'Withdraw',
  },
};
